import { render, staticRenderFns } from "./CandidateProgressionTable.vue?vue&type=template&id=4bbc69b5"
import script from "./CandidateProgressionTable.vue?vue&type=script&lang=js"
export * from "./CandidateProgressionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports